import Layout from 'components/Layout';
// import BlogList from "../../components/Blogs/BlogList/index";
import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { useRouter } from 'next/router';
import { remark } from 'remark';
import html from 'remark-html';
import { generateBlogUrl } from 'utils/blogs.util';
import SEO from 'components/Seo';
import { collectionPage } from 'data/Schema/blogSchema';
import BlogList from 'components/Blogs/BlogList';
import classes from './styles.module.scss';
import { FaChevronLeft } from 'react-icons/fa';
import Link from 'next/link';

const blogsDirectory = path.join(process.cwd(), 'blogs');

export async function getStaticProps() {
  const mdFiles = fs.readdirSync(blogsDirectory, {
    withFileTypes: true
  });

  let blogsData = [];

  for (let i = 0; i < mdFiles.length; i++) {
    const fileContent = fs.readFileSync(
      path.join(blogsDirectory, mdFiles[i].name),
      'utf-8'
    );

    const { data, content } = matter(fileContent);

    const slug = generateBlogUrl(data);

    const processedContent = await remark().use(html).process(content);
    const contentHtml = processedContent.toString();

    blogsData.push({
      data,
      contentHtml,
      slug
    });
  }

  const blogs = blogsData
    .filter(blog => blog)
    .sort((a, b) => new Date(b.data?.date) - new Date(a.data?.date));

  return {
    props: {
      BlogsData: blogs
    }
  };
}
export default function Blogs({ BlogsData }) {
  const router = useRouter();

  const schemaCodes = [
    {
      type: 'application/ld+json',
      code: JSON.stringify(collectionPage)
    }
  ];
  return (
    <Layout>
      <SEO
        title="Blogs"
        description="Blog Page for Sikka"
        url={router.pathname}
        keywords={['blog']}
        schemaCodes={schemaCodes}
      />
      <section className={classes.headerSection}>
        <Link href={'/'}>
          <FaChevronLeft />
        </Link>
        <h1>Blogs</h1>
      </section>
      <section className={classes.container}>
        <BlogList blogs={BlogsData} />
      </section>
    </Layout>
  );
}
